import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { NotificationsBadgeComponent } from './components/badge/notifications-badge.component';
import { NotificationsListComponent } from './components/list/notifications-list.component';
import { NotificationsRoutingModule } from './notifications-routing.module';
import { NotificationsService } from './notifications.service';
import { AgGridModule } from 'ag-grid-angular';
import { AuditLogComponent } from './components/audit-log/audit-log.component';

@NgModule({
	imports: [SharedModule, NotificationsRoutingModule, AgGridModule.withComponents([NotificationsListComponent])],
	declarations: [NotificationsBadgeComponent, NotificationsListComponent, AuditLogComponent],
	exports: [NotificationsBadgeComponent],
	providers: [NotificationsService]
})
export class NotificationsModule { }
